var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSagittarius(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sagittarius") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sagittarius",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shaft",
    fill: "#000000",
    points: "2 19.7785 3.414 21.1925 20.385 4.2215 18.97 2.8075"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Cross",
    fill: "#000000",
    points: "14.0208 16.2426 6.9498 9.1716 8.3638 7.7576 15.4348 14.8286"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Arrow",
    fill: "#000000",
    points: "11.1926 1.9999 11.1926 3.9999 19.1926 3.9999 19.1926 11.9999 21.1926 11.9999 21.1926 1.9999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSagittarius);
export default __webpack_public_path__ + "static/media/sagittarius.6af6f576ae9cb3c71ed4a602ab63ba85.svg";
export { ForwardRef as ReactComponent };